import "./style.scss";

import BPDashboard from "components/BPDashboard";

const BPDashboardPage = () => {
    return <BPDashboard />;
};

export default BPDashboardPage;
